import React, { useEffect, useRef, useState } from "react";
import { Form, Spin, Select, Modal, DatePicker, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { save } from "../../../../../../../features/save/saveSlice";
import { normalizeDateToLocalYear } from "../../../../../../../utils";
import { issueStatusData } from "../../../../../../../data";
import { fetchData } from "../../../../../../../features/fetch/fetchSlice";

const { TextArea } = Input;
const IssueAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const urlActivity = "api/v2/mainProject/activities/get";
  const urlMember = "api/v2/mainProject/member/get";
  const urlComponent = "api/v2/mainProject/components/get";

  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { dataActivity, dataMember, activeObjOngoingProject, dataComponent } =
    useSelector((state) => ({
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
      dataActivity: state.fetch.data[urlActivity] || [],
      dataMember: state.fetch.data[urlMember] || [],
      dataComponent: state.fetch.data[urlComponent] || [],
    }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [compSelected, setCompSelected] = useState(false); 
  const handleCompChange = async (value) => {
    setCompSelected(!!value);
    await dispatch(
      fetchData({
        url: urlActivity,
        limit: null,
        start: 0,
        paComponentId:value,
        paMainProject: activeObjOngoingProject?.projectId,
        paIsGroup: "false",
      })
    );
  };

  const onFinish = async (data) => {
    data.prjIssueId = prodd?.prjIssueId ? prodd?.prjIssueId : null;
    data.prjIssueMainProjectId = activeObjOngoingProject?.projectId;
    data.prjIssueStartDate = normalizeDateToLocalYear(data?.prjIssueStartDate);
    data.prjIssueEndDate = normalizeDateToLocalYear(data?.prjIssueEndDate);
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/mainProjects/issue/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
        prjIssueStartDate: prodd?.prjIssueStartDate
          ? dayjs(new Date(prodd?.prjIssueStartDate))
          : null,
        prjIssueEndDate: prodd?.prjIssueEndDate
          ? dayjs(new Date(prodd?.prjIssueEndDate))
          : null,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]); 
  return (
    <Modal
      title={`${prodd?.prjIssueId ? "Update Issue" : "Create an Issue"}`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[59.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="prjIssueComponentId"
            className=""
            label={"Select Component"}
            rules={[
              {
                required: true,
                message: "Please select component",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                dataComponent?.length > 0 &&
                dataComponent?.map((item) => ({
                  value: item?.componentId,
                  label: item?.compName,
                }))
              }
              onChange={handleCompChange}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <Form.Item
            name="prjIssueActivityId"
            className=""
            label={"Select Activity"}
            rules={[
              {
                required: true,
                message: "Please select activity",
              },
            ]}
          >
            <Select
              disabled={!compSelected}
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                dataActivity?.length > 0 &&
                dataActivity?.map((item) => ({
                  value: item?.paId,
                  label: item?.activityName,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <Form.Item
            name="prjIssueName"
            className=""
            label={"Issue Name"}
            rules={[
              {
                required: true,
                message: "Please add Issue Name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="prjIssueMemberId"
            className=""
            label={"Responsible Person"}
            rules={[
              {
                required: true,
                message: "Please select responsible person",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                dataMember?.length > 0 &&
                dataMember?.map((item) => ({
                  value: item?.pmId,
                  label: item?.pmName,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>

          <Form.Item
            name="prjIssueStartDate"
            rules={[
              {
                required: false,
                message: "Start date is required",
              },
            ]}
            label="Start Date"
          >
            <DatePicker format={"YYYY MMM DD"} className="input" />
          </Form.Item>

          <Form.Item
            name="prjIssueEndDate"
            rules={[
              {
                required: false,
                message: "End date is required",
              },
            ]}
            label="End Date"
          >
            <DatePicker format={"YYYY MMM DD"} className="input" />
          </Form.Item>
          <Form.Item
            name="prjIssueStatus"
            className=""
            label={"Status"}
            rules={[
              {
                required: true,
                message: "Please select status",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                issueStatusData?.length > 0 &&
                issueStatusData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>
        </div>
        <Form.Item
          name="prjIssueRemarks"
          className=""
          label={"Remarks"}
          rules={[
            {
              required: true,
              message: "Please add remarks",
            },
          ]}
        >
          <TextArea placeholder="Remarks..." rows={5} className="text_area" />
        </Form.Item>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? (
                  <Spin />
                ) : prodd?.prjIssueId ? (
                  "Update Issue"
                ) : (
                  "Create an Issue"
                )}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default IssueAdd;
